import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'dayjs/locale/it';

dayjs.extend(isSameOrBefore);
dayjs.locale('it');

const Calendar = ({ selectedDate, setSelectedDate, orders }) => {

  const selectedDateObj = dayjs(selectedDate);
  const todayObj = dayjs();

  const [currentMonth, setCurrentMonth] = useState(() =>
    selectedDateObj.startOf("month")
  );

  useEffect(() => {
    const newSel = dayjs(selectedDate);
    if (newSel.format("YYYY-MM") !== currentMonth.format("YYYY-MM")) {
      setCurrentMonth(newSel.startOf("month"));
    }
  }, [selectedDate]);

  const daysInMonth = currentMonth.daysInMonth();
  const firstDayOfMonth = currentMonth.startOf("month").day();

  const safeOrders = orders || {};

  const handleDayClick = (day) => {
    const clickedDate = currentMonth.date(day).format("YYYY-MM-DD");
    setSelectedDate(clickedDate);
  };

  const handleMonthChange = (direction) => {
    setCurrentMonth((prev) => {
      const newMonth = prev.add(direction, "month").startOf("month");
      setSelectedDate(newMonth.format("YYYY-MM-DD"));
      return newMonth;
    });
  };

  return (
    <div style={{ padding: 16, background: "#fff", borderRadius: 12 }}>

      {/* Header navigazione mese */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <button
          onClick={() => handleMonthChange(-1)}
          style={{
            padding: "7px 16px", borderRadius: 8,
            border: "1px solid #e5e7eb", background: "#f9fafb",
            fontSize: 13, fontWeight: 500, color: "#374151",
            cursor: "pointer", fontFamily: "inherit",
            transition: "background 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#f3f4f6"}
          onMouseLeave={e => e.currentTarget.style.background = "#f9fafb"}
        >
          Indietro
        </button>

        <h2 style={{
          fontSize: 16, fontWeight: 600, color: "#111827",
          textTransform: "capitalize", margin: 0,
        }}>
          {currentMonth.format("MMMM YYYY")}
        </h2>

        <button
          onClick={() => handleMonthChange(1)}
          style={{
            padding: "7px 16px", borderRadius: 8,
            border: "1px solid #e5e7eb", background: "#f9fafb",
            fontSize: 13, fontWeight: 500, color: "#374151",
            cursor: "pointer", fontFamily: "inherit",
            transition: "background 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#f3f4f6"}
          onMouseLeave={e => e.currentTarget.style.background = "#f9fafb"}
        >
          Avanti
        </button>
      </div>

      {/* Legenda */}
      <div style={{
        display: "flex", justifyContent: "center", gap: 20,
        padding: "8px 12px", background: "#f9fafb",
        borderRadius: 8, margin: "0 0 14px",
        flexWrap: "wrap",
      }}>
        {[
          { bg: "#fbbf24", border: "#f59e0b", label: "Giorno selezionato" },
          { bg: "#fecaca", border: "#f87171", label: "Ordini mancanti" },
        ].map(({ bg, border, label }) => (
          <div key={label} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{
              width: 10, height: 10, borderRadius: "50%",
              background: bg, border: `1.5px solid ${border}`,
              flexShrink: 0, display: "inline-block",
            }} />
            <span style={{ fontSize: 11, color: "#6b7280" }}>{label}</span>
          </div>
        ))}
      </div>

      {/* Griglia giorni */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>

        {/* Intestazioni giorni settimana */}
        {["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"].map((d) => (
          <div key={d} style={{
            textAlign: "center", fontSize: 11, fontWeight: 600,
            color: "#9ca3af", padding: "4px 0", letterSpacing: "0.04em",
          }}>
            {d}
          </div>
        ))}

        {/* Celle vuote per allineare il primo giorno */}
        {[...Array(firstDayOfMonth).keys()].map((_, index) => (
          <div key={`empty-${index}`} />
        ))}

        {/* Giorni del mese */}
        {[...Array(daysInMonth).keys()].map((_, index) => {
          const day = index + 1;
          const dateObj = currentMonth.date(day);
          const formattedDate = dateObj.format("YYYY-MM-DD");

          const isSelected  = dateObj.isSame(dayjs(selectedDate), "day");
          const isToday     = dateObj.isSame(todayObj, "day");
          const isPassedDay = dateObj.isSameOrBefore(todayObj, "day") && !isToday;
          const isFuture    = dateObj.isAfter(todayObj, "day");
          const hasOrders   = safeOrders[formattedDate] && safeOrders[formattedDate].length > 0;

          // Calcola stile in base allo stato del giorno
          let bg, color, border, fontWeight, opacity;
          bg = "#fff"; color = "#374151"; border = "1px solid transparent";
          fontWeight = 400; opacity = 1;

          if (isSelected) {
            bg = "#fbbf24"; color = "#111827";
            border = "1px solid #f59e0b"; fontWeight = 700;

          } else if (isToday) {
            bg = "#fff"; color = "#4f46e5";
            border = "2px solid #4f46e5"; fontWeight = 700;

          } else if (isPassedDay) {
            if (hasOrders) {
              // ✅ CON ordini → bianco normale
              bg = "#fff"; color = "#6b7280";
              border = "1px solid #f3f4f6";
            } else {
              // ✅ SENZA ordini → rosso per segnalare che mancano
              bg = "#fecaca"; color = "#b91c1c";
              border = "1px solid #f87171"; fontWeight = 600;
            }

          } else if (isFuture) {
            bg = "#fff"; color = "#d1d5db"; opacity = 0.6;
          }

          return (
            <button
              key={formattedDate}
              onClick={() => handleDayClick(day)}
              style={{
                background: bg, color, border, fontWeight, opacity,
                borderRadius: 8, padding: "8px 4px",
                fontSize: 13, cursor: "pointer",
                fontFamily: "inherit", textAlign: "center",
                transition: "all 0.15s",
                WebkitTapHighlightColor: "transparent",
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.background = isPassedDay && !hasOrders
                    ? "#fca5a5"
                    : isToday ? "#eef2ff" : "#f3f4f6";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = bg;
              }}
            >
              {day}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;